import {FilterSeatsValueObject} from '../../search/ValueObjects/FilterSeatsValueObject.js'
import {ListSharedValueObject} from '../../shared/ValueObjects/ListSharedValueObject.js'

export class ListSeatsOptionsValueObject extends ListSharedValueObject {
  constructor({value}) {
    super({value})
  }

  static createFromApiResponse({items}) {
    this.validate({value: items})
    const seats = items.map(item => {
      return FilterSeatsValueObject.create({
        seats: item.seats,
        label: item.label
      })
    })

    return new ListSeatsOptionsValueObject({value: seats})
  }

  getFilterOptions() {
    return this.value.map(seat => {
      const {seats, label} = seat
      return {
        id: seats.join('-'),
        value: seats,
        label
      }
    })
  }
}
